export const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
        ? "https://localhost:44347/api"
        : "api";
